<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6596 2.3405C10.5391 -0.780014 5.46133 -0.780322 2.3405 2.3405C-0.780321 5.46133 -0.780014 10.5387 2.3405 13.6596C5.46102 16.7804 10.5387 16.7804 13.6596 13.6596C16.7801 10.5387 16.7801 5.46102 13.6596 2.3405ZM11.1563 11.1563C10.9158 11.3967 10.5261 11.3967 10.2857 11.1563L8.00004 8.87059L5.6057 11.2649C5.36528 11.5053 4.97556 11.5053 4.73515 11.2649C4.49473 11.0245 4.49473 10.6348 4.73515 10.3944L7.12948 8.00004L4.84381 5.71437C4.60339 5.47395 4.60339 5.08392 4.84381 4.84381C5.08423 4.60339 5.47395 4.60339 5.71437 4.84381L8.00004 7.12948L10.1767 4.95279C10.4172 4.71237 10.8069 4.71237 11.0473 4.95279C11.2877 5.1932 11.2877 5.58292 11.0473 5.82334L8.87059 8.00004L11.1563 10.2857C11.3967 10.5261 11.3967 10.9158 11.1563 11.1563Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#66B015'
    },
    width: {
      type: String,
      default: '16'
    },
    height: {
      type: String,
      default: '16'
    }
  },
  computed: {
    viewbox() {
      return `0 0 25 25`
    }
  }
}
</script>
